import { FintechSoftwareDevelopmentPage } from './FintechSoftwareDevelopmentPage';

export default FintechSoftwareDevelopmentPage;
